<template>
  <div
    data-qa="appointment_club_view"
    :class="appointmentViewClassList"
  >
    <ClubBaseLayout
      :pdf-data="pdfData"
      use-centered-slot-data
    >
      <template #club-base-layout-body>
        <ClubAppointmentPreloader v-if="viewState === viewSteps.appProgress" />
        <ClubAppointmentError
          v-if="viewState === viewSteps.appError"
          @[eventClubReturnFromErrorView]="handleReturnFromErrorView"
        >
          <template #club-error-html>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="currentErrorStore.description" />
          </template>
        </ClubAppointmentError>
        <ClubAppointmentFailed
          v-else-if="viewState === viewSteps.payFailed"
          :coupon-request-id="couponRequest.id"
          @[eventClubClickPayment]="handleEventClickPayment"
        />
        <ClubPendingPayment
          v-else-if="viewState === viewSteps.appWithOffer"
          :card-price="couponRequest.cardPrice"
          :coupon-request-id="couponRequest.id"
          :has-email="!!couponRequest.email"
          :life-time-seconds="couponRequest.lifeTimeSeconds"
          :total-price="couponRequest.totalPrice"
          @club:prepayment="handleEventClubPrepayment"
          @club:countdown-expired="handleEventCountdownExpired"
          @club:send-email-success="handleEventSendEmailSuccess"
          @club:click-payment="handleEventClickPayment"
        />
        <ClubTimeoutExpired
          v-else-if="viewState === viewSteps.appWithoutOffer"
          :doctor-page-url="doctorPageUrl"
          :full-price="couponRequest.fullPrice"
          :is-cancel="isCancelByExpired"
        />
      </template>
      <template
        v-if="viewState === viewSteps.appWithoutOffer && !isCancelByExpired"
        #club-base-layout-prepend-footer
      >
        <SuccessDetail
          :style="appointmentSuccessDetailStyleList"
          :detail-appointment-link="detailAppointmentLink"
          :town-url="townUrl"
          @club:redirect-to-medtochka="handleEventRedirectToMedtochka"
        />
      </template>
    </ClubBaseLayout>
  </div>
</template>

<script>
import { TIMEOUT_DATA } from 'www/vue_components/common/Club/constants'
import { alertUserErrors } from 'www/vue_components/common/Club/functions'
import { requestGoWithoutPrepayment } from 'www/vue_components/common/Club/api'

import ManageYandexGoals from 'www/vue_components/common/mixins/ManageYandexGoals'
import { MOBILE_CLUB_YANDEX_GOALS, CLUB_YANDEX_GOALS, APPOINTMENT_YANDEX_GOALS } from 'www/yandexGoals'

import {
  ClubErrorData,
  ClubStyleData,
  ClubPriceList,
  ClubGlobalData,
  ClubCommonData,
  ClubEventsNames,
  ClubRedirectURLs,
  ClubWidgetData,
  ClubAppointmentViewStates,
} from 'www/vue_components/common/Club/mixins'

import ClubBaseLayout from 'www/vue_components/common/Club/components/base/ClubBaseLayout/ClubBaseLayout.vue'
import ClubTimeoutExpired from 'www/vue_components/common/Club/components/dependencies/ClubTimeoutExpired/ClubTimeoutExpired.vue'
import ClubAppointmentError from 'www/vue_components/common/Club/components/dependencies/ClubAppointment/ClubAppointmentError.vue'
import ClubAppointmentFailed from 'www/vue_components/common/Club/components/dependencies/ClubAppointment/ClubAppointmentFailed.vue'
import ClubAppointmentPreloader from 'www/vue_components/common/Club/components/dependencies/ClubAppointment/ClubAppointmentPreloader.vue'

import { sendYaGoal } from 'www/vue_components/common/AppointmentPage/functions'
import ClubPendingPayment from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/ClubPendingPayment.vue'
import SuccessDetail from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/SuccessDetail.vue'

export default {
  name: 'ClubAppointmentView',
  components: {
    SuccessDetail,
    ClubPendingPayment,
    ClubBaseLayout,
    ClubTimeoutExpired,
    ClubAppointmentError,
    ClubAppointmentFailed,
    ClubAppointmentPreloader,
  },
  mixins: [
    ClubErrorData,
    ClubStyleData,
    ClubPriceList,
    ClubGlobalData,
    ClubCommonData,
    ClubEventsNames,
    ClubRedirectURLs,
    ClubWidgetData,
    ClubAppointmentViewStates,
    ManageYandexGoals,
  ],
  props: {
    isThisParent: {
      type: Boolean,
      default: false,
    },
    isDirect: {
      type: Boolean,
      required: true,
    },
    loadingState: {
      type: Boolean,
      default: false,
    },
    couponRequestData: {
      type: Object,
      default: () => ({}),
    },
    medtochkaDetailUrl: {
      type: String,
      default: '',
    },
    doctorPageUrl: {
      type: String,
      default: '',
    },
    lpuTimedelta: {
      type: Number,
      default: null,
    },
    slotDateString: {
      type: String,
      default: '',
    },
    townUrl: {
      type: String,
      default: '',
    },
  },
  data: vm => ({
    isLoadingState: vm.loadingState,
    medtochkaUrl: vm.medtochkaDetailUrl,
    clubTimeoutExpired: false,
    isSentYaGoalExpiredTimer: false, // поле для ликвидации дублирования отправки цели 'appointmentExpiredTimer'
    unwatchCouponRequestId: () => {},
    yaGoalsList: {
      ...CLUB_YANDEX_GOALS,
      ...MOBILE_CLUB_YANDEX_GOALS,
    },
    couponRequest: vm.couponRequestData,
  }),
  computed: {
    isViewOffer() {
      return this.isDirect && this.couponRequest.dateCreated
    },
    isCancelByExpired() {
      if (
        !this.slotDateString
        || this.lpuTimedelta === null
        || this.serverTimedelta === null
      ) {
        return false
      }

      const oneHourTime = 60 * 60 * 1000
      // Разница в часовом поясе между клиникой и сервером
      const timedeltaTimeDiff = (this.lpuTimedelta - this.serverTimedelta) * oneHourTime

      // Время окончания таймера
      const couponRequestDateTime = new Date(this.couponRequest.dateCreated).getTime()
      const timerTimeCountdown = couponRequestDateTime + this.couponRequest.lifeTime * 60 * 1000

      const slotDateTime = new Date(this.slotDateString).getTime() - timedeltaTimeDiff
      const restTimeToAppointment = slotDateTime - timerTimeCountdown

      return restTimeToAppointment > oneHourTime
    },
  },
  watch: {
    loadingState(isLoadingState) {
      this.isLoadingState = isLoadingState
    },
    medtochkaDetailUrl(medtochkaUrl) {
      this.medtochkaUrl = medtochkaUrl
    },
    isLoadingState: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.viewState = this.viewSteps.appProgress
        }
      },
    },
    isViewOffer() {
      setTimeout(() => {
        this.viewState = this.viewSteps[this.getOfferState()]
        this.sendYaGoalAppointmentOfferState()
      }, TIMEOUT_DATA.preloader)
    },
    'currentErrorStore.has': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.setErrorViewState()
        }
      },
    },
    couponRequestData(value) {
      this.couponRequest = value
    },
  },
  mounted() {
    if (this.isThisParent) {
      this.couponRequestIdChanged()

      const isErrorState = this.currentErrorStore.has

      if (isErrorState) {
        this.setErrorViewState()
        return
      }

      if (this.paymentStatus === this.paymentStatuses.canceled) {
        this.viewState = this.viewSteps.payFailed

        return
      }

      this.viewState = this.viewSteps[this.getOfferState()]

      setTimeout(() => { // callback истечения таймера срабатывает позже. Поэтому выношу отправку цели из потока
        this.sendYaGoalAppointmentOfferState()
      })

      return
    }

    this.unwatchCouponRequestId = this.$watch('couponRequest.id', this.couponRequestIdChanged)
  },
  methods: {
    handleEventClubPrepayment() {
      this.sendYandexGoal('clickPaymentButton')
    },
    handleEventRedirectToMedtochka() {
      this.sendYandexGoal('appointmentRedirectToMedtochka')
    },
    handleEventPaymentRedirectToMedtochka() {
      this.sendYandexGoal('paymentSuccessRedirectToMedtochka')
    },
    handleEventClubDownloadCoupon() {
      this.sendYandexGoal('downloadCoupon')
    },
    handleClubResponseAppointment({ detail }) {
      this.couponRequest = detail.couponRequest
      this.isLoadingState = detail.loadingState
      this.medtochkaUrl = detail.medtochkaDetailUrl

      this.couponRequestIdChanged()
    },
    handleClubResponseError({ detail }) {
      this.$set(this, 'dataErrorStore', detail.dataErrorStore)
    },
    handleEventCountdownExpired() {
      this.clubTimeoutExpired = true

      if (!this.isSentYaGoalExpiredTimer) {
        this.isSentYaGoalExpiredTimer = true
        this.sendYandexGoal('appointmentExpiredTimer')
      }

      if (this.viewState !== this.viewSteps.payStart) {
        this.viewState = this.viewSteps.appWithoutOffer
      }
    },
    handleReturnFromErrorView() {
      if (this.isMobileDevice) {
        window.scrollTo(0, 0)
      }

      if (this.currentErrorStore.key === 'patient_has_record') {
        window.location.assign(document.referrer)
        return
      }

      if (this.currentErrorStore.key === 'slot_already_busy') {
        window.location.href = window.location.href.replace(/&slot=[^&]*/, '')
        return
      }

      window.location.reload()
    },
    handleEventSendEmailSuccess({ response } = {}) {
      this.setResponseData({ response })

      if (this.clubPrivilegeCurrentUserWithoutCard) {
        this.sendYandexGoal('sendPaymentEmailUserWithoutCard')
      }

      this.sendYandexGoal('sendPaymentEmail')
      this.redirectToPayment()
    },
    handleEventClickPayment({ response } = {}) {
      this.setResponseData({ response })
      this.redirectToPayment()
    },
    handleEventClubGoWithoutPrepayment() {
      this.sendYandexGoal('clickGoWithoutPrepayment')
      this.isLoadingState = true

      requestGoWithoutPrepayment({
        couponRequestId: this.couponRequest.id,
      }).then(this.handleResponseCancelledPayment).catch(error => {
        alertUserErrors(error)
      })
    },
    handleResponseCancelledPayment() {
      sendYaGoal(APPOINTMENT_YANDEX_GOALS.successDirect)
      sendYaGoal('common_appointment_page__direct_success_message')

      this.$emit('club:payment-cancelled')
    },
    setErrorViewState() {
      this.setErrorDescription()

      this.isLoadingState = false
      this.viewState = this.viewSteps.appError
    },
    getOfferState() {
      return this.clubTimeoutExpired ? 'appWithoutOffer' : 'appWithOffer'
    },
    couponRequestIdChanged() {
      this.updatePaymentUrl()
      this.unwatchCouponRequestId()
    },
    sendYaGoalAppointmentOfferState() {
      if (this.viewState === this.viewSteps.appWithoutOffer && !this.isSentYaGoalExpiredTimer) {
        this.isSentYaGoalExpiredTimer = true
        this.sendYandexGoal('appointmentExpiredTimer')

        return
      }

      if (this.viewState === this.viewSteps.appWithOffer) {
        this.sendYandexGoal('appointmentSuccess')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.club-appointment-view {
  width: 100%;
  height: 100%;

  &_mobile {
    display: block;
    background-color: $ui-kit-bg-gray-0;
  }
}
</style>
